import { useRequest } from "hooks/useRequest";

export const useInventoryFormulaRequester = () => {
	const request = useRequest("inventoryFormula");

	return {
		...request,
	};
};
